var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotPinnedIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.279 0.266196L19.7336 5.72074C19.9935 5.98074 20.0712 6.37168 19.9306 6.71134C19.7899 7.05099 19.4585 7.27248 19.0909 7.27256H16.5199C16.0178 7.27256 15.6108 6.86555 15.6108 6.36347C15.6108 5.86139 16.0178 5.45438 16.5199 5.45438H16.8962L14.5454 3.10356V3.47992C14.5455 3.77623 14.4013 4.054 14.1588 4.22429L6.57441 9.5492C6.42138 9.65665 6.23894 9.7143 6.05195 9.71429H3.10359L10.2854 16.8961V13.9478C10.2855 13.7684 10.3386 13.5929 10.438 13.4436L13.5236 8.81556C13.7019 8.54107 14.0141 8.38365 14.3408 8.40343C14.6676 8.4232 14.9585 8.61712 15.1024 8.91112C15.2463 9.20512 15.2211 9.55381 15.0363 9.82401L12.1036 14.223V19.0907C12.1035 19.4584 11.882 19.7899 11.5423 19.9305C11.2027 20.0712 10.8117 19.9935 10.5517 19.7335L7.19631 16.378L1.37686 19.8702C1.01915 20.0848 0.561266 20.0285 0.266286 19.7335C-0.0286928 19.4385 -0.0850535 18.9806 0.129587 18.6229L3.62159 12.8029L0.267042 9.44838C0.0077486 9.18817 -0.0697079 8.7976 0.0706593 8.45813C0.211026 8.11866 0.541699 7.89684 0.909042 7.89574H5.76477L12.7272 3.00765V0.908923C12.7273 0.541291 12.9488 0.209892 13.2884 0.0692161C13.6281 -0.0714602 14.019 0.0062798 14.279 0.266196ZM4.94695 14.1285L3.55995 16.4398L5.87122 15.0527L4.94695 14.1285Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotPinnedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notPinnedIcon.7eae733437349d9ab2f20fb32b138f4f.svg";